export default "__VITE_ASSET__CFIcS5fG__"